import React from 'react';
import PropTypes from 'prop-types';
import { Map, TileLayer, GeoJSON, ZoomControl } from 'react-leaflet';
import { CONFIG } from '../config';

import { formatNumber } from '../utilities/helpers';
import SelectionNotAvailable from './SelectionNotAvailable';

const heatMapColours = [
  '#000',
  'rgb(38,38,80)',
  'rgb(65,80,98)',
  'rgb(139,178,178)',
  'rgb(155,155,155)',
  'rgb(216,216,216)',
  'rgb(0,0,0,0)',
];

const styleFeature = feature => {

  if (feature.properties.borderData) {
    return ({
      color: '#32ABE1',
      fillColor: heatMapColours[feature.properties.colour],
      fillOpacity: 0,
      weight: 1
    })
  } else {
    return ({
      color: 'white',
      fillColor: heatMapColours[feature.properties.colour],
      fillOpacity: 0.8,
      weight: 1
    })

  }

};


const Heatmap = ({ mapData, isGeographyTab, adm4, isDataAvailable, showTotalCount = false }) => {
  /*
  if(isGeographyTab){ // only show border in geography tab
    mapData.featureCollection.features.unshift({
      geometry: mapData.enclosure,
      properties:{
        colour: 6,
        borderData: true,
      },
      type: "Feature"
    })
  }*/

  const boundary = [[mapData.bbox[1], mapData.bbox[0]], [mapData.bbox[3], mapData.bbox[2]]];

  const [hoverInfo, setHoverInfo] = React.useState({
    colour: 0,
    count: 0,
    id: '',
    level: 0,
    name: '',
  });

  const [showInfo, setShowInfo] = React.useState(false);

  const highlightFeature = e => {
    const layer = e.target;
    if (!layer.feature.properties.borderData) { // if hover to actual map data
      if (layer && layer.feature) {
        setHoverInfo(layer.feature.properties);
      }
      layer.setStyle({
        fillOpacity: 1,
      });

      setShowInfo(true);
      layer.bringToFront();
    }
  };

  const resetFeature = e => {
    const layer = e.target;
    setShowInfo(false);
    layer.setStyle({
      fillOpacity: 0.8,
    });
  };

  const renderLegend = (idx, item, length) => {

    switch (idx) {
      case 0:
        return item[0] % 1 === 0 ? `> ${formatNumber(item[0])}` : `> ${item[0].toFixed(2)}%`
      case idx = length - 1:
        return item[1] % 1 === 0 ? `> ${formatNumber(item[1])}` : `< ${item[1].toFixed(2)}%`
      default:
        return item[0] % 1 === 0 ? `${formatNumber(item[0])} > ${formatNumber(item[1])}` : `${item[0].toFixed(2)}% > ${item[1].toFixed(2)}%`
    }
  }

  let propertiesTotalCount = 0;

  mapData.featureCollection.features &&
  mapData.featureCollection.features.forEach((item)=>{
    propertiesTotalCount += item.properties.count
  })


  return (
    <React.Fragment>
      {isDataAvailable
        ?
        <div
          className="Heatmap"
          onMouseOut={() => setShowInfo(false)}
          onBlur={() => setShowInfo(false)}
        >
          <Map
            bounds={boundary}
            zoomControl={false}
            dragging={!isGeographyTab}
            doubleClickZoom={false}
            touchZoom={false}
            center={mapData.latlng}
            zoomSnap={0}
            scrollWheelZoom={false}
            className="Heatmap_map"
          >
            {!isGeographyTab && (
              <ZoomControl position={'bottomleft'} />
            )}

            <TileLayer
              url={`https://api.mapbox.com/styles/v1/landmarks/${CONFIG.MAPBOX_STYLE_URL}/tiles/256/{z}/{x}/{y}?access_token=${CONFIG.MAPBOX_TOKEN}`}
              attribution={
                'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ' +
                '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                'Imagery © <a href="http://mapbox.com">Mapbox</a>'
              }
              id="mapbox.light"
            />
            <GeoJSON
              key={Math.random()}
              data={mapData.featureCollection}
              style={styleFeature}
              onEachFeature={(feature, layer) => {
                layer.on({
                  mouseover: highlightFeature,
                  mouseout: resetFeature,
                });
              }}

            />
          </Map>
          {showInfo && (
            <div
              className="Heatmap_hoverInfo"
              style={{
                // transform: `translateX(${coords.x}px) translateY(${
                //   coords.y
                // }px) translateZ(0)`,
                // WebkitTransform: `translateX(${coords.x}px) translateY(${
                //   coords.y
                // }px) translateZ(0)`,
              }}
            >
              <span className="Heatmap_hoverInfo_name">{(adm4 && isGeographyTab) ? '' : hoverInfo.name}</span>
              <span className="Heatmap_hoverInfo_count">{isGeographyTab ? hoverInfo.count : `${hoverInfo.count.toFixed(2)}%`}</span>
            </div>
          )}

          {showTotalCount && (
            <div className="Heatmap_totalCount">
              {propertiesTotalCount}

            </div>

          )}

          <div className="Heatmap_legend">
            <ul className="Heatmap_legend_ul">
              {
                mapData.legend && (
                  mapData.legend.map((item, index) => (
                    <li className="Heatmap_legend_li" key={`${item[0]} - ${item[1]}`}>
                      <span
                        className="Heatmap_legend_square"
                        style={{ backgroundColor: heatMapColours[index] }}
                      />
                      <span className="Heatmap_legend_text">
                        {renderLegend(index, item, mapData.legend.length)}
                      </span>
                    </li>
                  ))
                )}
            </ul>
          </div>
        </div>
        : <SelectionNotAvailable
          text='Graph Currently Unavailable'
          buttonText=''
        />

      }
    </React.Fragment>
  );
};

Heatmap.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  mapData: PropTypes.object.isRequired,
};

export default Heatmap;
